// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"b9562d0d","403":"0fde44e9","453":"90b286ba","502":"92e7280a","564":"fbb1df01","578":"82b83fbe","788":"c36189fe","836":"41742277","857":"97889ea8","936":"b0099110"}[chunkId] + ".chunk.js";
};